import { ReviewList } from "components/templates/ReviewList";
import { GetStaticPaths, GetStaticProps } from "next";
import { NextSeo, NextSeoProps } from "next-seo";
import { useRouter } from "next/router";
import { repository } from "repositories";
import {
  useFortuneTeller,
  useFortuneTellerReviewList,
} from "repositories/hooks";
import { handleServerSideError } from "shared/utils/ssr";
import { Paths } from "utils/routes";
import getNextSeoProps from "utils/ssr/getNextSeoProps";

const perPage = 30;

interface Props {
  nextSeoProps: NextSeoProps;
}

const FortuneTellerReviewList = ({ nextSeoProps }: Props) => {
  const { query } = useRouter();

  const { fortuneTeller, isLoading: isLoadingFortuneTeller } = useFortuneTeller(
    query.id
  );
  const { data, size, setSize, isValidating } = useFortuneTellerReviewList(
    query.id,
    { limit: perPage }
  );

  const pages = data?.map((page) => page.reviews) ?? [];
  const isLoading = isLoadingFortuneTeller || !data || isValidating;
  const onLoadMore = () => setSize(size + 1);
  const hasNextPage = data && size < data[0].meta.totalPages;

  return (
    <>
      <NextSeo {...nextSeoProps} />
      <ReviewList
        title={fortuneTeller?.name && `${fortuneTeller?.name}のレビュー・感想`}
        fortuneTeller={fortuneTeller}
        pages={pages}
        isLoading={isLoading}
        onLoadMore={onLoadMore}
        hasNextPage={hasNextPage}
      />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  try {
    const { fortuneTeller } = await repository.fortuneTeller
      .getMetaData(ctx.params.id)
      .data();
    const { meta } = await repository.fortuneTellerReview
      .getList(ctx.params.id)
      .data();

    return {
      props: {
        nextSeoProps: await getNextSeoProps(ctx, {
          title: `口コミ一覧 : ${fortuneTeller.name} - MIROR(ミラー) | 登録無料で当たると話題のチャット占い・電話占い！`,
          description: `当たると評判の${fortuneTeller.name}への口コミです。日本最大級のインターネット占い館MIROR(ミラー)では、${fortuneTeller.name}への口コミ${meta.totalCounts}件を掲載しています。`,
          canonical: `https://miror.jp${Paths.fortuneTellers.reviews(
            ctx.params.id
          )}`,
        }),
      },
    };
  } catch (error) {
    return handleServerSideError(error);
  }
};

export default FortuneTellerReviewList;
